import getTokenData from './get-token-data';

export default (token: string): string => {
    const { payload } = getTokenData(token);
    // sub for guest tokens, PartyUID for auth tokens
    const userid: string = payload.sub || payload.PartyUID || '';
    return userid;
};
